import { pick } from 'lodash-es';
import { useApi2call } from 'containers/Api2/index.js';
import parseMeeting from './parseMeeting.js';
import { removeTempId } from '../Planner/filterData.js';
import stringifyVideoInfo from './stringifyVideoInfo.js';

const MEETING_FIELDS = ['id', 'studentId', 'parentIds', 'meetingLocationType', 'videoMeeting'];

function useSaveMeetings() {
  const api2call = useApi2call();
  return ((setId, meetings) => {
    const body = { meetings: meetings.map((m) => pick(removeTempId(stringifyVideoInfo(m)), MEETING_FIELDS)) };
    const options = {
      method: 'POST',
      url: `meetings/sets/${setId}/meetings`,
      replaceOnSuccess: true,
      body,
      parser: parseMeeting,
      withPromise: true,
    };
    return api2call(options);
  });
}

export default useSaveMeetings;
